/* eslint-disable react-hooks/rules-of-hooks */
import { put, takeLatest } from "redux-saga/effects";
import { call } from "redux-saga/effects";
import { authActions } from "./authSlice";
import loginApi from "api/loginApi";
import { ApiResponse, Login, Logout } from "models";
import { meActions } from "./meSlice";
import { toast } from "react-toastify";

function* resendOtp(payload: Login) {
  try {
    const response: ApiResponse = yield call(loginApi.getResendOtp, payload);
    const data: ApiResponse = response?.data;
    if (data.success) {
      toast.success(data.message);
      yield put(authActions.resendOtpSuccess(data));
    } else {
      yield put(authActions.resendOtpFailed(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    if (errorData) {
      toast.error(errorData?.message || "Something went wrong");
      yield put(authActions.resendOtpFailed(errorData));
    } else {
      toast.error(error.message || "Network Error");
      yield put(authActions.resendOtpFailed(error));
    }
  }
}

function* handleLogin(payload: Login) {
  try {
    const response: ApiResponse = yield call(loginApi.verifyOtp, payload);
    const data: ApiResponse = response?.data;
    if (data.success) {
      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("meProfile", JSON.stringify(data));
      // sessionStorage.setItem("phone", payload?.payload?.phone);
      toast.success(data.message);
      yield put(authActions.loginSuccess(data));
      // Dispatch getMeSuccess using the data returned from login
      yield put(meActions.getMeSuccess(data as any));
    } else {
      yield put(authActions.loginFailed(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    if (errorData) {
      toast.error(errorData?.message || "Something went wrong");
      yield put(authActions.loginFailed(errorData));
    } else {
      toast.error(error.message || "Network Error");
      yield put(authActions.loginFailed(error));
    }
  }
}

function* handleLogout(payload: Logout) {
  try {
    const response: ApiResponse = yield call(loginApi.userLogout, payload);
    const data: ApiResponse = response?.data;
    if (data.success) {
      yield put(authActions.logoutSuccess(data));
      yield put(authActions.clearData());
      yield put(meActions.clearMe());
      sessionStorage.clear();
    } else {
      yield put(authActions.logoutFailed(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(authActions.logoutFailed(errorData));
  }
}

function* clearData() {}

export function* authSaga() {
  yield takeLatest(authActions.resendOtp.type, resendOtp);
  yield takeLatest(authActions.login.type, handleLogin);
  yield takeLatest(authActions.logout.type, handleLogout);
  yield takeLatest(authActions.clearData.type, clearData);
}
